import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Card, CardHeader, Button, Collapse, CardBody, FormGroup, Label, Input, FormFeedback } from 'reactstrap';
import { CoreLocalADConfiguration } from '../../../../../../models/CoreLocalAdModels';
import BlobConnection from '../../../../../storageContainer/BlobConnection';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';


export const validator = (configuration: CoreLocalADConfiguration, active: boolean) => {
    const validation = [];

    if (active) {
        if (!configuration.blobContainerUrl || configuration.blobContainerUrl === "") {
            validation.push('blobContainerUrl');
        }
        if (!configuration.blobName || configuration.blobName === "") {
            validation.push('blobName');
        }
        if (!configuration.blobSourceKey || configuration.blobSourceKey === "") {
            validation.push('blobSourceKey');
        }
    }
    return validation;
}


interface LocalAdConfigurationProps {
    configuration: CoreLocalADConfiguration
    disabled: boolean
    updatePart: (part: Partial<CoreLocalADConfiguration>) => void
    active: boolean
    onValidChange: (arg: boolean) => void 
}

const LocalAdConfiguration = (props: LocalAdConfigurationProps) => {
    const { t } = useTranslation(['common', 'configuration']);
    const [open, setOpen] = useState<boolean>(true);

    const validation = validator(props.configuration, props.active);

    useEffect(() => {
        props.onValidChange(validation.length ? true : false)
    }, [props.configuration, props.active]);

    const updateLocalAdConfiguration = (name: string, value: string) => {
        let updatedValue: string | null = value;

        if (!value.length) {
            updatedValue = null
        }

        props.updatePart({ [name]: updatedValue });
    }

    return (
        <Card className="edit_module">
            <CardHeader tag="h2">
                <Button outline color="secondary" style={{ width: '37px', float: 'right' }} onClick={() => setOpen(!open)}>{open ? '-' : '+'}</Button>
                <span>
                    {t('modules.LocalAD.title', { ns: 'common' })}
                    <a href="https://flowsync.se/help/modules/supplementary/schooladmin-usermapping" target="_blank">
                        <FontAwesomeIcon className="documentation-icon" title={t('showHelp', { ns: 'common' })} icon="question-circle" /></a>
                </span>
            </CardHeader>
            <Collapse isOpen={open}>
                <CardBody>
                    <div style={{ margin: '1rem 0' }}>
                        <FormGroup>
                            <Label for="blobContainerUrl">{t('moduleView.localAd.linkContainer', { ns: 'configuration' })}</Label>
                            <Input
                                type="text"
                                name="blobContainerUrl"
                                id="blobContainerUrl"
                                placeholder={t('moduleView.localAd.linkContainer', { ns: 'configuration' })}
                                disabled={props.disabled}
                                value={props.configuration.blobContainerUrl || ''}
                                onChange={(e) => updateLocalAdConfiguration('blobContainerUrl', e.target.value)}
                                invalid={validation.indexOf('blobContainerUrl') !== -1}
                                autoComplete="off"
                            />
                            <FormFeedback>{t('moduleView.localAd.linkContainerFeedback', { ns: 'configuration' })}</FormFeedback>
                        </FormGroup>
                        <FormGroup>
                            <Label for="blobName">{t('genericTableHeaders.name', { ns: 'common' })}</Label>
                            <Input
                                type="text"
                                name="blobName"
                                id="blobName"
                                placeholder={t('genericTableHeaders.name', { ns: 'common' })}
                                value={props.configuration.blobName || ''}
                                disabled={props.disabled}
                                onChange={(e) => updateLocalAdConfiguration('blobName', e.target.value)}
                                invalid={validation.indexOf('blobName') !== -1}
                                autoComplete="off"
                            />
                            <FormFeedback>{t('moduleView.localAd.nameFeedback', { ns: 'configuration' })}</FormFeedback>
                        </FormGroup>
                        <FormGroup>
                            <Label for="blobSourceKey">{t('moduleView.localAd.blobSource', { ns: 'configuration' })}</Label>
                            <Input
                                type="text"
                                name="blobSourceKey"
                                id="blobSourceKey"
                                placeholder={t('moduleView.localAd.blobSource', { ns: 'configuration' })}
                                value={props.configuration.blobSourceKey || ''}
                                disabled={props.disabled}
                                invalid={validation.indexOf('blobSourceKey') !== -1}
                                onChange={(e) => updateLocalAdConfiguration('blobSourceKey', e.target.value )}
                                autoComplete="off"
                            />
                            <FormFeedback>{t('moduleView.localAd.blobSourceFeedback', { ns: 'configuration' })}</FormFeedback>
                        </FormGroup>

                        <BlobConnection
                            blob={{
                                blobContainerUrl: props.configuration.blobContainerUrl,
                                blobName: props.configuration.blobName,
                                blobSourceKey: props.configuration.blobSourceKey,
                            }}
                        />
                    </div>
                </CardBody>
            </Collapse>
        </Card>
    )
}

export default LocalAdConfiguration;
